module.exports = __webpack_public_path__ + "static/man-avg-452942d48677c5656ae49de1083df8de.jpg";